import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  formatRxUseLabel,
  rxStatusLabel,
} from '../../../../constants/rx-names';

@Component({
  selector: 'app-rx-history-dialog',
  template: `
    <h2 mat-dialog-title>VIEW ALL RX HISTORY</h2>
    <mat-dialog-content>
      <p class="rx-history-message">
        Active, hidden, and expired prescriptions. Hide removes an RX from
        normal RX USE without deleting it.
      </p>
      <table class="rx-history-table" *ngIf="rows.length">
        <thead>
          <tr>
            <th>RX NAME</th>
            <th>EXAM DATE</th>
            <th>EXPIRES</th>
            <th>STATUS</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let row of rows"
            (click)="select(row.rx)"
            [class.rx-history-hidden]="row.status === 'HIDDEN'"
          >
            <td>{{ row.name }}</td>
            <td>{{ row.exam }}</td>
            <td>{{ row.expires }}</td>
            <td>{{ row.status }}</td>
          </tr>
        </tbody>
      </table>
      <p *ngIf="!rows.length">No prescription history for this patient.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close()">CLOSE</button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .rx-history-message {
        margin: 0 0 12px;
        font-size: 13px;
        line-height: 1.4;
      }
      .rx-history-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 13px;
      }
      .rx-history-table th,
      .rx-history-table td {
        text-align: left;
        padding: 8px 6px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      }
      .rx-history-table tbody tr {
        cursor: pointer;
      }
      .rx-history-table tbody tr:hover {
        background: rgba(0, 0, 0, 0.04);
      }
      .rx-history-hidden td {
        color: rgba(0, 0, 0, 0.54);
      }
    `,
  ],
})
export class RxHistoryDialogComponent {
  rows: Array<{
    rx: any;
    name: string;
    exam: string;
    expires: string;
    status: string;
  }> = [];

  constructor(
    public dialogRef: MatDialogRef<RxHistoryDialogComponent, any>,
    @Inject(MAT_DIALOG_DATA) public data: { prescriptions?: any[] }
  ) {
    this.rows = (data?.prescriptions || []).map((rx) => ({
      rx,
      name: formatRxUseLabel(rx).split(' — ')[0],
      exam: this.shortDate(rx.examDate),
      expires: this.shortDate(rx.expirationDate),
      status: rxStatusLabel(rx),
    }));
  }

  select(rx: any): void {
    this.dialogRef.close(rx);
  }

  private shortDate(value?: string | Date): string {
    if (!value) {
      return '—';
    }
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) {
      return '—';
    }
    return `${date.getMonth() + 1}/${date.getDate()}/${String(
      date.getFullYear()
    ).slice(-2)}`;
  }
}
